module.exports = __webpack_public_path__ + "static/img/8-title.54b8de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/8-title.png
// module id = QaZn
// module chunks = 0